import { configStore } from "@/store/store";

export const OXYGEN_TEMPLATE_POST_TYPE = "oxygen_template";
export const BREAKDANCE_TEMPLATE_POST_TYPE = "breakdance_template";

export const OXYGEN_HEADER_POST_TYPE = "oxygen_header";
export const BREAKDANCE_HEADER_POST_TYPE = "breakdance_header";

export const OXYGEN_FOOTER_POST_TYPE = "oxygen_footer";
export const BREAKDANCE_FOOTER_POST_TYPE = "breakdance_footer";

export const OXYGEN_BLOCK_POST_TYPE = "oxygen_block";
export const BREAKDANCE_BLOCK_POST_TYPE = "breakdance_block";

function isOxygen() {
  return (
    configStore.builderMode === "oxygen" ||
    window.Breakdance.builderMode === "oxygen"
  );
}

export function isGlobalBlockType(postType: string) {
  return (
    postType === OXYGEN_BLOCK_POST_TYPE ||
    postType === BREAKDANCE_BLOCK_POST_TYPE
  );
}

export function getBreakdanceTemplatePostType() {
  return isOxygen() ? OXYGEN_TEMPLATE_POST_TYPE : BREAKDANCE_TEMPLATE_POST_TYPE;
}

export function getBreakdanceHeaderPostType() {
  return isOxygen() ? OXYGEN_HEADER_POST_TYPE : BREAKDANCE_HEADER_POST_TYPE;
}

export function getBreakdanceFooterPostType() {
  return isOxygen() ? OXYGEN_FOOTER_POST_TYPE : BREAKDANCE_FOOTER_POST_TYPE;
}

export function getBreakdanceBlockPostType() {
  return isOxygen() ? OXYGEN_BLOCK_POST_TYPE : BREAKDANCE_BLOCK_POST_TYPE;
}
